import React, { useState } from "react";

import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { setBackUrl } from "../../appRedux/actions/Auth";
import { DropdownItem } from "../BP2Components/Dropdown/Dropdown";
import { Dropdown, Button } from "../BP2Components";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";

import IntlMessages from "../../util/IntlMessages";

import "./ProcessesDropdown.less";

interface ProcessesDropdownProps {
   api_instanceStatus: Array<any>;
   type: "dropdown" | "list";
}

const ProcessesDropdown: React.FC<ProcessesDropdownProps> = ({
   api_instanceStatus,
   type = "dropdown"
}) => {
   const [isOpen, setIsOpen] = useState(false);
   const history = useHistory();
   const { user } = useSelector((state: RootStateOrAny) => state);
   const dispatch = useDispatch();

   const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      setIsOpen(!isOpen);
   };

   const goToInstance = (item: DropdownItem) => {
      const instanceId = item.id;
      // dispatch(setBackUrl(window.location.pathname));
      history.push(`/messages/${instanceId}?instanceId=${instanceId}`);
   };

   const getClassNameForItem = (instanceItem: any) => {
      let className = "";
      if (type === "dropdown" && api_instanceStatus?.length > 1) {
         className += "processes-dropdown__item";
      } else {
         className += "processes-list__item";
      }

      if (user.oldId && instanceItem.instanceStepAvailableFor.includes(user.oldId.toString())) {
         if (type === "dropdown" && api_instanceStatus?.length > 1) {
            className += " processes-dropdown__item-available";
         } else {
            className += " processes-list__item-available";
         }
      }

      return className;
   };

   const items: Array<DropdownItem> = api_instanceStatus?.map((instanceItem) => ({
      id: instanceItem.id,
      name: `${instanceItem.name}\n${instanceItem.owner !== "Undefined" ? instanceItem.owner : ""}`,
      value: instanceItem.id,
      disabled: user.oldId
         ? !instanceItem.instanceStepAvailableFor.includes(user.oldId.toString())
         : true,
      buttonType: "link",
      customItemClassName: getClassNameForItem(instanceItem),
      link: `/messages/${instanceItem.id}?instanceId=${instanceItem.id}`
   }));

   return (
      <>
         {type === "dropdown" && items?.length > 1 ? (
            <>
               <Button className="processes-dropdown__button" onClick={handleClick}>
                  <IntlMessages id="kanban.processes" />
               </Button>
               <Dropdown
                  items={items}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  className="processes-dropdown"
                  onOptionClick={goToInstance}
               />
            </>
         ) : items?.length > 0 ? (
            <div className="processes-list">
               {items.map((item) =>
                  item.disabled ? (
                     <p
                        onClick={() => dispatch(setBackUrl(window.location.pathname))}
                        className={item?.customItemClassName}
                        style={{ cursor: "not-allowed" }}
                     >
                        {item.name}
                     </p>
                  ) : (
                     <Link
                        onClick={() => dispatch(setBackUrl(window.location.pathname))}
                        to={item?.link ? item?.link : ""}
                        target="_self"
                        className={item?.customItemClassName}
                     >
                        {item.name}
                     </Link>
                  )
               )}
            </div>
         ) : (
            <p className="processes-dropdown-no-data">
               <IntlMessages id="modal.zeroProcesses" />
            </p>
         )}
      </>
   );
};

export default ProcessesDropdown;
